module.exports = __webpack_public_path__ + "img/hongtouwenjian.79620ae0.png";